import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/index/index.vue'; // 首页
import Center from './views/center/center.vue'; // 个人中心
import myCurriculum from './views/my-curriculum/my-curriculum.vue'; // 我的课程
import squareCurriculum from './views/square-curriculum/square-curriculum.vue'; // 课程广场
// 展示组件
import List from './views/list/list.vue'; //列表卡片
import TeacherList from './views/list/teacher.vue'; //教师列表卡片
import ShowTab from './views/showtab.vue'; //滚动tab
import Intro from './views/course-components/intro.vue';
import Rate from './views/course-components/rate.vue';
import informationEditing from './views/center/information-editing.vue'; // 个人中心信息编辑
import proposal from './views/center/proposal.vue'; // 反馈
import ShowProgress from './views/showprogress.vue'; //进度条
import SearchPage from './views/search-page.vue'; //搜索页
import ShowTitle from './views/showtitle.vue'; //搜索页
import Charts from './views/charts.vue'; //图表组件页

Vue.use(Router);
import vuex from '@/store/index';

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      title: '页面滚动',
      navName: '页面滚动'
    }
  },
  {
    path: '/center',
    name: 'Center',
    component: Center,
    meta: {
      title: '个人中心',
      navName: '个人中心'
    }
  },
  {
    path: '/myCurriculum',
    name: 'myCurriculum',
    component: myCurriculum,
    meta: {
      title: '我的课程',
      navName: '我的课程'
    }
  },
  {
    path: '/squareCurriculum',
    name: 'squareCurriculum',
    component: squareCurriculum,
    meta: {
      title: '功能列表',
      navName: ''
    }
  },
  {
    path: '/list',
    name: 'list',
    component: List,
    meta: {
      title: '列表卡片',
      navName: ''
    }
  },
  {
    path: '/teacherList',
    name: 'teacherList',
    component: TeacherList,
    meta: {
      title: '教师列表卡片',
      navName: ''
    }
  },
  {
    path: '/showTab',
    name: 'showTab',
    component: ShowTab,
    meta: {
      title: '滚动tab栏',
      navName: ''
    }
  },
  {
    path: '/intro',
    name: 'intro',
    component: Intro,
    meta: {
      title: '介绍组件'
    }
  },
  {
    path: '/rate',
    name: 'rate',
    component: Rate,
    meta: {
      title: '评分组件'
    }
  },
  {
    path: '/information-editing',
    name: 'information-editing',
    component: informationEditing,
    meta: {
      title: '个人中心信息编辑'
    }
  },
  {
    path: '/showProgress',
    name: 'showProgress',
    component: ShowProgress,
    meta: {
      title: '进度条',
      navName: ''
    }
  },
  {
    path: '/searchPage',
    name: 'searchPage',
    component: SearchPage,
    meta: {
      title: '搜索页',
      navName: ''
    }
  },
  {
    path: '/showTitle',
    name: 'showTitle',
    component: ShowTitle,
    meta: {
      title: '标题栏',
      navName: ''
    }
  },
  {
    path: '/proposal',
    name: 'proposal',
    component: proposal,
    meta: {
      title: '反馈建议'
    }
  },
  {
    path: '/charts',
    name: 'charts',
    component: Charts,
    meta: {
      title: '图表组件'
    }
  }
];

let router = new Router({
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return {
        x: 0,
        y: 0
      };
    } else {
      return savedPosition;
    }
  }
});

export default router;

function setTitle(to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    let str = /\(i[^;]+;( U;)? CPU.+Mac OS X/;
    if (navigator.userAgent.match(str)) {
      const hackIframe = document.createElement('iframe');
      hackIframe.style.display = 'none';
      hackIframe.src = '/fixIosTitle.html?r=' + Math.random();
      document.body.appendChild(hackIframe);
      setTimeout(_ => {
        document.body.removeChild(hackIframe);
      }, 300);
    }
  }
}

function ctrlNavBar(to, from, next) {
  if (to.meta.navName) {
    //需要navBar的页面
    vuex.dispatch('AgettabberSwite', true);
    vuex.dispatch('AgetnavbarText', to.meta.navName);
  } else {
    vuex.dispatch('AgettabberSwite', false);
  }
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   document.title = to.meta.title;
  //   // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
  //   let str = /\(i[^;]+;( U;)? CPU.+Mac OS X/;
  //   if (navigator.userAgent.match(str)) {
  //     const hackIframe = document.createElement('iframe');
  //     hackIframe.style.display = 'none';
  //     hackIframe.src = '/fixIosTitle.html?r=' + Math.random();
  //     document.body.appendChild(hackIframe);
  //     setTimeout(_ => {
  //       document.body.removeChild(hackIframe);
  //     }, 300);
  //   }
  // }
  setTitle(to, from, next);
  ctrlNavBar(to, from, next);
  next();
});
